import axios from 'axios';
import Cookies from 'js-cookie';
import { create } from 'zustand';

// cookie ids
export const SCCLIENT = 'scagencysessid';
export const SCCLIENTID = 'scagencyuserid';

/**
 * @typedef {Object} AuthStore
 * @property {Object} session
 * @property {Function} isSignedIn
 * @property {Function} signIn
 * @property {Function} signOut
 */

/**
 * Auth Store
 *
 * @returns {AuthStore}
 */
export const useAuthStore = create((set, get) => ({
	session: { id: Cookies.get(SCCLIENT), userId: Cookies.get(SCCLIENTID) }, // also created and ttl
	isSignedIn: () => !!get().session?.id && !!get().session?.userId,
	signIn: async (credentials) => {
		const { data } = await axios.post('/coords/login', credentials);
		set(() => ({ session: data }));
		const createdAt = new Date(data.created);
		const expiresAt = new Date(createdAt.getTime() + data.ttl * 1000);
		Cookies.set(SCCLIENT, data.id, { expires: expiresAt });
		Cookies.set(SCCLIENTID, data.userId, { expires: expiresAt });
		axios.defaults.headers.common['Authorization'] = data.id;
	},
	signOut: () => {
		delete axios.defaults.headers.common['Authorization'];
		Cookies.remove(SCCLIENT);
		Cookies.remove(SCCLIENTID);
		set(() => ({ session: undefined }));
	},
}));
